module.exports = __webpack_public_path__ + "no-kudos.svg?75b3c06221df339b7479cfbf17b1b6b7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/no-kudos.svg
// module id = 277
// module chunks = 0